let mobileBreakpoint = 980;

(() => {
  const throttle = function (fn, wait) {
    var time = Date.now();
    return function (e) {
      if (time + wait - Date.now() < 0) {
        fn(e);
        time = Date.now();
      }
    };
  };

  if (document.querySelector(".table-of-contents")) {
    let viewportWidth;
    let setViewportWidth = function () {
      viewportWidth = window.innerWidth || document.documentElement.clientWidth;
    };

    const toc_spacer = document.querySelector(".table-of-contents__spacer");

    const toc = document.querySelector(".table-of-contents");
    const tocTop = toc.offsetTop + 640;

    document.addEventListener(
      "scroll",
      throttle((e) => {
        // console.log(window.scrollY, tocTop);
        if (window.scrollY > tocTop && viewportWidth >= mobileBreakpoint) {
          toc_spacer.classList.add("table-of-contents__spacer--sticky");
          toc.classList.add("table-of-contents--sticky");
        } else {
          toc_spacer.classList.remove("table-of-contents__spacer--sticky");
          toc.classList.remove("table-of-contents--sticky");
        }
      }, 10)
    );

    var checkBrowserWidth = function () {
      if (viewportWidth <= mobileBreakpoint) {
        toc.classList.remove("table-of-contents--sticky");
      }
    };

    setViewportWidth();
    checkBrowserWidth();

    window.addEventListener(
      "resize",
      function () {
        setViewportWidth();
        checkBrowserWidth();
      },
      false
    );
  }
})();
